import React from 'react'

const icelandPost = {
    id: 'hot-pots-of-iceland',
    type: 'post',
    countryId: 'iceland',
    title: 'The Hot Pots of Iceland',
    longDate: 'June 28th, 2018',
    month: 'June',
    date: '28',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Laugarvellir.jpg',
    coverImagePosition: 'bottom',
    content: [
        {
            text: (
                <div>Iceland is a magical place. The majority of Icelanders believe the country is populated by <a href="https://www.theatlantic.com/international/archive/2013/10/why-so-many-icelanders-still-believe-in-invisible-elves/280783/">huldufólk</a>, invisible elves. The land is unlike any other, a treeless moonscape with electric green moss-covered lava outflows and ice blue rivers ribboned across black gravel. Geothermal energy powers the island, bubbling underneath the surface and breaking free at thousands of tiny hot spring fissures. We've been obsessed since first going in 2013, and spent three weeks there at the beginning of this trip exploring more of the island.</div>
            )
        },
        {
            text: (
                <div>One of our favorite activities is seeking out and soaking in hot springs, also known as hot pots. Some have been enclosed and turned into swimming pools or spas. Many others are located in someone's field or next to a tiny stream on a mountain. We're listing the ones we've been to here, but there are tons of others, many of which are less explored by tourists and hard to find. One tip is to visit local tourist offices in small towns as you drive around. They'll be very knowledgeable about activities in the area and any local hot springs. And if you're <a href='https://www.rent.is/blog/driving-the-highlands-in-iceland/'>driving off the Ring Road into the highlands</a>, you should have a 4x4 vehicle that is approved to go on the highland roads (these cost more to rent, but open up way more possibilities) and check the <a href='http://www.road.is/travel-info/road-conditions-and-weather/entire-iceland-road-conditions-map/'>road conditions</a>, which can be bad any time of year.
                </div>
            )
        },
        {
            text: (
                <div>There are also tons of swimming pools, all powered by geothermal energy, all over Iceland. Swimming is a required activity in high schools, and in most towns you can find a pool. Take one or two swim suits and get in your daily exercise or soak. Bonus: If you're sleeping in a camper van, you can shower there, included in the low pool fees (usually $5-10.)
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Hofsos.jpg',
            detailText: 'The pool and hot tubs at Hofsós, with mind-boggling views.'
        },
        {
            header: 'The Semi-Natural'
        },
        {
            subheader: 'Seljavallalaug'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Seljavallalaug2.jpg'
        },
        {
            text: (
                <div>Tourism has completely exploded in Iceland in the past few years. When we went five years ago, the government had just started their program of subsidizing flights to increase tourism. It worked better than expected. Back then, I could only find one blog post talking about Seljavallalaug and how to get there. Now, it's on Google Maps (along with all the other "hidden" things in Iceland) and there are so many people visiting, the farm owners have put up signs begging people to stop knocking on their door asking for directions. But this gem is one of my favorite things we've been to from both trips. You bathe at the foot of the famous Eyjafjallajökull volcano which famously erupted in 2010. The pool is fed at one end by the Seljavellir geothermal spring but the other end can be chilly. It feels forgotten and secluded.
                </div>
            )
        },
        {
            text: (
                <div>It's also still off the literal beaten path. To reach Seljavallalaug, which is just west of Skogafoss on the Ring Road, you turn in on the 242 and continue straight to park past the farm. Then you have a pretty long walk along a gravel pathway beside a river (with one possible river crossing, depending on the time of year.) Just keep going in the direction of the river/glacier until you see the pool.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Seljavallalaug1.jpg',
            detailText: 'The walk to Seljavallalaug.'
        },
        {
            subheader: 'Reykjafjarðarlaug'
        },
        {
            text: (
                <div>The hot springs here come in two types: a shallow, painted concrete swimming pool and a sit-in-the-river spot upstream. If you're visiting the Westfjords, definitely make a stop here for incredible and secluded views of the fjord. While the Westfjords are not known for incredible hot springs, check out <a href='https://guidetoiceland.is/connect-with-locals/regina/hot-pools-in-the-westfjords-of-iceland'>this post</a> from someone who lives there for a full list.
                </div>
            )
        },
        {
            text: (
                <div>One note: Try to wear your suit there. The "changing facilities" are a dirty shack that's clearly been abandoned and the worst toilet I saw in Iceland.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Reykjafjarðarlaug.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Reykjafjarðarlaug2.jpg'
        },
        {
            header: 'The Wilderness Ones'
        },
        {
            subheader: 'Landmannalaugar'
        },
        {
            text: (
                <div>Landmannalaugar is probably the most-visited site in the highlands. It's close enough to Reykjavik that several bus companies run there, multiple times a day – a good option if you're not renting a 4x4. Since we were backpacking on the <a href='/post/laugavegur'>Laugavegur trail</a> from Landmannalaugar to Þórsmörk, we booked <a href='https://www.re.is/iceland-on-your-own'>bus tickets</a> ahead of time to get there and back.
                </div>
            )
        },
        {
            text: (
                <div>The campsites and large dormitories at Landmannalaugar are situated in an area of immense geothermal activity. There are multiple hikes in the area that take you through hillsides peppered with naturally steaming vents. The swamp-like river that winds past camp is situated across some of these hot springs, so parts of the river are wonderfully warm to hang out in (though you might need to wade through a bit of cold river to get there!) If you've seen pictures of people sitting in a steaming river, it was most likely here.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Landmannalaugar.jpg',
            detailText: (
                <div>Sadly our camera died, so here's a borrowed photo. Photo credit: <a href='http://carpemundo.com/iceland-trek/'>Carpe Mundo</a>.</div>
            )
        },
        {
            text: (
                <div>If you're planning on doing the Laugavegur trek, we recommend building in an extra day and night at Landmannalaugar at the beginning so you can soak in the springs without needing to immediately put on hiking clothes (possibly aided by some of the alcohol available for purchase in the on-site trailer – the last time you'll be able to buy anything on the trek.) There are also a ton of short hikes you can do in the area and we'd highly recommend it – it's some of the most beautiful landscapes you'll see in Iceland, which is saying a lot.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Landmannalaugar2.jpg',
            detailText: 'Sunset at Landmannalaugar. Photo credit: Katie Ingram, who we met on the trip.'
        },
        {
            subheader: 'Landbrotalaug'
        },
        {
            text: (
                <div>We visited this hot pot back in 2013 as part of a guided tour of the Snæfellsnes peninsula. At that time, our tour guide seemed a bit crazy as he drove the van around a deserted swampy area, walked around, and finally gestured for us to follow him – revealing a tiny, crystal clear, rock-rimmed pool surrounded by nothing but mist and mountains. We crammed in cozily with the rest of the tour group and shared a few beers. After the trip, we had a photo of the spot printed on canvas and hung it up in our apartment; it's one of Peter's favorite things.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Landbrotalaug2.jpg',
            detailText: 'The photo we had made into a canvas print.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Landbrotalaug1.jpg',
            detailText: 'Young us with tour groupers and solo cups.'
        },
        {
            text: (
                <div>The spot is unmarked, but many sites have now published the GPS coordinates. You'll need to walk about 5 minutes from the nearest parking spot on a gravel road; basic rental cars should be fine on it, but if you're nervous you can park on the main paved road and walk 20 minutes.
                </div>
            )
        },
        {
            text: (
                <div>GPS coordinates for Landbrotalaug Hot Springs (gravel) Road: (64.833770, -22.290662)</div>
            )
        },
        {
            text: (
                <div>GPS coordinates for the actual hot springs: (64.49933 -22.19110)
                </div>
            )
        },
        {
            subheader: 'Laugarvellir'
        },
        {
            text: (
                <div>This HOT WATERFALL is hands down the coolest discovery we made on our 2018 trip, and it seems that not many people know about it. It's a bizarre and incredible experience to strip down to your swimsuit in a cold wind next to a freezing river, then jump into the hot pot and stand under a rush of hot water.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Laugarvellir.jpg',
        },
        {
            text: (
                <div>Getting to Laugarvellir was quite the adventure. You are definitely supposed to have a 4x4 to go on the road to get there, and I wish we had, but we met a ranger/tourist information officer at the nearby dam who said our camper van would be fine on the roads. We have a different definition of "fine." The road started out gravelly but OK going about 20 mph, and quickly devolved into a boulder field. We eventually parked the van and walked the rest of the way. There's a pretty deep river crossing just before the waterfall that you definitely can't do without a vehicle that looks like it belongs at a monster truck rally.
                </div>
            )
        },
        {
            text: (
                <div>Here's a <a href='https://mapcarta.com/17603082'>helpful map</a>, since this is not on Google. To get there from the Ring Road in the East, you'll take the 95 to the 931 headed to Litlanesfoss. The junction just after the dam bridge is where we stopped and consulted a map, and met the information officer who was very helpful. South just a little bit on the 933, the 910 winds away to the west. You stay on it until it basically dead ends at the river (or, cross the river in your 4x4. On our way back out we hitched a ride from some Icelanders who had a massive truck.) Whatever you do, make sure you have GPS on your phone or otherwise!
                </div>
            )
        },
        {
            subheader: 'Fosslaug'
        },
        {
            text: (
                <div>We never would have heard of or found this hot pot without visiting the tourist information office in Varmahlið. It's the perfect temperature, and we soaked for half an hour or so while chatting to some Canadians who had found it through a GoPro video. It was definitely an adventure and a search to find it! Fosslaug is located on a river just above a great waterfall (Reykjafoss), but there are no signs for the roads leading to it or the path to walk there. From Varmahlið, drive south along the 752 and take a right on the 753. Pass Sauerbær farm on the left, cross the river, then take two rights when the road forks. If you look at the map, you're trying to stay close to the river. Drive a few hundred yards until you come to a fence gate with a sign on it asking you not to drive any further. Walk through the gate along the path until you get to a wooden footbridge; cross it onto the island. Walk to the other side going either directly straight across the top or around the left side. To get to a great view of the waterfall, just follow the river flow. Most likely, you'll have this spot all to yourself.
                </div>
            )
        },
        {
            text: (
                <div>Search for Reykjafoss on Google Maps to help navigate.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Fosslaug.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Fosslaug2.jpg',
            detailText: 'The foss (waterfall) at Fosslaug: Rekjafoss.'
        },
        {
            subheader: 'Hellulaug'
        },
        {
            text: (
                <div>Hellulaug was probably the most disappointing hot spring we went to, but that doesn't mean it's not a cool spot; we'd just been spoiled by some awesome and sparsely visited springs a few days earlier. It has a nice view of Vatnsfjörður fjord leading out to the ocean, and you can pair it with going to the local swimming pool in Flókalundur (well sign-posted.) One note: the hot pot is not where Google Maps says it is. It's up the road about 500m north of Flókalundur on the 60. You can't see it easily from the road and we missed the sign the first time, but pull over the first spot you can on the right after you drive north past the hotel/campground.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/Hellulaug.jpg',
        },
        {
            header: 'The Spas'
        },
        {
            subheader: 'Laugarvatn Fontana'
        },
        {
            text: (
                <div><a href='https://www.fontana.is/en/sauna'>Laugarvatn Fontana</a> was a godsend after three weeks living out of a backpack. The steam rooms are naturally fed by the steam from the geothermal springs and get up to 140°F. We rotated between the natural pool, super hot tub, steam room or sauna, and an icy dip in the lake. Then we did the set all over again as many times as our bodies could take! We felt amazing afterward, and I'm pretty sure it's the only way we were able to handle the last couple of rainy days sleeping in sub-par beds before our flight.
                </div>
            )
        },
        {
            text: (
                <div>Peter talked to a woman in the steam room who had been going to Laugarvatn Fontana since she was a little girl growing up in the town. Back then, they just encased the hot spring in a wooden hut to create the steam room – no spa or fancy hot tubs. While it used to be free and now is definitely not, she still loves it.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/LaugarvatnFontana.jpg',
        },
        {
            subheader: 'Blue Lagoon'
        },
        {
            text: (
                <div>It's touristy, it's expensive, but it's still a must-do on any trip to Iceland. Blue Lagoon is between the Keflavik airport and Reykjavik, so the best way to maximize your trip is to do it on the way in or out of the country and utilize their luggage storage. The rest of the natural hot springs on this list are set in a pool of rocks, mud, and algae, but there are some types of geothermal activity including at Blue Lagoon that produce a white, claylike mineral covering the bottom of the pools. Sitting in the pools with steam rising off the ice blue and milky white water is an experience you won't get anywhere else, and won't forget.
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/BlueLagoon2.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/hotPots/BlueLagoon1.jpg',
        },
        {
            header: 'The Rest'
        },
        {
            text: (
                <div>Of course, there are tons of hot pots we didn't have time to get to. Here's a partial list, if you're planning a trip to Iceland.
                    <ul>
                        <li>Mývatn (called "the North's answer to the Blue Lagoon")</li>
                        <li>Hveravellir (read about it <a href='https://www.extremeiceland.is/en/what-to-do-in-iceland/2828-free-hot-springs-around-iceland-exotic-bathing'>here</a>)</li>
                        <li>Gamla Laugin "Secret Lagoon" (read about it <a href='https://asideofsweet.com/hidden-hot-springs-iceland-travel/'>here</a>)</li>
                        <li>Gvendarlaug (read about it <a href='https://guidetoiceland.is/connect-with-locals/regina/hot-pools-in-the-westfjords-of-iceland'>here</a>)</li>
                        <li>Reykjadalur (read about it <a href='https://livelifewithaview.com/8-reasons-why-you-need-to-hike-reykjadalur-hot-springs/'>here</a>, though it may be <a href='https://icelandmag.is/article/reykjadalur-geothermal-valley-closed-hikers-avoid-further-damage-vegetation'>closed</a>)</li>
                        <li>Opnur, Hrunalaug, Kualaug, Englandshverir, Hvalfjarðarlaug (read about them <a href='https://grapevine.is/travel/traveling-on-your-own/2014/12/29/listicle-thermal-pools-in-the-south-of-iceland/'>here</a>)</li>
                    </ul>
                </div>
            )
        }
    ]
}

export default icelandPost



// WEBPACK FOOTER //
// ./src/Posts/Content/HotPots.js